export default [
  {
    path: '/machineControl', name: 'machineControl', component: () => import('@/pages/machine/machineControl/machineControl'), meta: { title: '设备控制' },
  },
  {
    path: '/onlineRecord', name: 'onlineRecord', component: () => import('@/pages/machine/onlineRecord/onlineRecord'), meta: { title: '上线/离线记录' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/machine.js